import { useEffect, useState } from 'react';
import { COLOR, GREYSCALE, PirateShipColor } from '../styles/colors';

const useHighlightColor = (
  error: boolean,
  focused: boolean,
  autofilled?: boolean,
): PirateShipColor => {
  const [highlightColor, setHighlightColor] = useState<PirateShipColor>(GREYSCALE.grey30);
  useEffect(() => {
    if (error) {
      setHighlightColor(COLOR.red);
    } else if (focused || autofilled) {
      setHighlightColor(COLOR.blue);
    } else {
      setHighlightColor(GREYSCALE.grey30);
    }
  }, [error, focused, autofilled]);
  return highlightColor;
};

export default useHighlightColor;
